import CartItemTemplate from '@maison/components/common/CartItemTemplate';
import ProductPrice from '@phoenix/components/common/ProductPrice.vue';
import { CURRENT_COUNTRY_CHANGED, emitter } from '@phoenix/event-bus';

export default {
  components: {
    CartItemTemplate,
    ProductPrice,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      currentCountry: window.Phoenix.currentCountry,
    };
  },

  mounted() {
    emitter.on(CURRENT_COUNTRY_CHANGED, () => {
      this.currentCountry = window.Phoenix.currentCountry;
    });
  },

  computed: {
    localizedPrice() {
      if (this.currentCountry && this.item.price?.[this.currentCountry]) {
        return this.item.price[this.currentCountry];
      }

      return '';
    },
  },
};
